import { taskMarkerStyle } from "helpers/map";
import { formatNumber } from "helpers/system";
import React from "react";
import { CircleMarker, Tooltip } from "react-leaflet";

export default function TemperatureValuePoint({ temperatureValue }) {
    if (!temperatureValue) {
        return null;
    }

    const { location, values } = temperatureValue;
    const loc = [location[1], location[0]];

    return (
        <CircleMarker center={loc} {...taskMarkerStyle} color="#e5443c" pane="markerPane">
            <Tooltip className="map__tooltip--default" direction="top">
                <span>
                    Значения температуры
                    <br />
                    {values.map((value, i) => (
                        <div key={i}>{formatNumber(value)}</div>
                    ))}
                </span>
            </Tooltip>
        </CircleMarker>
    );
}
